import { ru } from '../../data/ru';
import { by } from '../../data/by';
import API from "../../API";

import React, {useEffect, useState} from 'react';
import GetQuestionsResult from "./getQuestionsResult";

const GetLastTest = ({userId}) => {
	let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdFour : by.RoleIdFour;

	const [results,setResults] = useState([])
	const [isOpen,setIsOpen] = useState(false)
	const [testNumber,setTestNumber] =useState(null)
	const api = new API();

	const userRole =localStorage.getItem('type')

	const getResult =()=>{
		api.getLastResult(userId)
			.then(data => {
					setResults(data)
					console.log(data)
				}
			)
	}

	useEffect(()=>{
		if(userRole==='Student') {
			getResult()
		}
	},[])

	const handlerModal =()=>{
		setIsOpen(prev=>!prev)
	}
	const handlerModalTeacher = async ()=>{
		await getResult()
		setIsOpen(prev=>!prev)
	}
	const handlerTestResult =(number)=>{
		setTestNumber(number)
	}
	const handlerClose = () =>{
		setIsOpen(false)
		setTestNumber(null)

	}

	const typeQuestion =(number)=> {
		return results[number]?.tasks?.map((task) => {
			return (
				<div className={'student_result_test'} key={task.name}>
					<div style={{display: 'flex', justifyContent: 'space-between'}}>
						<p className="student_new-task-p">{task.name} </p>
						<p className="student_new-task-p"> {language.points} {task.scores}/{task.max_scores}</p>
					</div>
					{task.questions.map((question) => (
						<GetQuestionsResult question={question} key={question.description+task.name}/>
					))}
				</div>
			)
		})
	}
	const modalTestsName=results.length !==0 ?results.map((item,i)=> {
		return(
			<div className='student_result_test' key={item.test_name}>
				<div className="student-last-test">
					<p>{item.test_name} </p>
					<p>{language.points}</p>
					<div>

					</div>
					<div>
						<p>{item.scores}/{item.max_scores}</p>
					</div>
					<div>
						<button className="student-test-podr-button" onClick={() => {handlerTestResult(i)}}>
							{language.explanation}
						</button>
					</div>
				</div>
			</div>)
	}):
		<p className="test-prover-false" style={{marginTop: "2vh"}}> {language.NoTestsPassed}</p>


	const modalWindow =<div className="student_modal">
								<div className="student_modal-body">
									<button className="student_cancel-button"
											onClick={() =>handlerClose() }>&times;</button>
									<ol>
										{Number.isInteger(testNumber) ?typeQuestion(testNumber):modalTestsName}
									</ol>
								</div>
							</div>




	const labelLastTest=	 (!results || results.length === 0)?
			 <p className="test-prover-false" style={{marginTop: "2vh"}}> {language.NoTestsPassed}</p>
		 :
					<div>
						<div className='student_result_test'>
							<div className="student-last-test">
								<p>{results[0].test_name} </p>
								<p>{language.points}</p>
								<div>

								</div>
								<div>
									<p>{results[0].scores}/{results[0].max_scores}</p>
								</div>
								<div>
									<button className="student-test-podr-button"
											onClick={() => handlerModal()}>{language.explanation}
									</button>
								</div>
							</div>
						</div>
					</div>
	const labelTeacher = <button className='profile_edit-open'
								 onClick={() => handlerModalTeacher()}>?</button>
	return (
		<div>
			{userRole==='Student'&& labelLastTest}
			{userRole==='Teacher'&& labelTeacher}
			{isOpen && modalWindow}

		</div>
	);
};

export default GetLastTest;